import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { DistributionsPanelComponent } from './lib/distributions-panel.component'
import { DistributionsKey } from './panel-key'

export * from './lib/distributions.module'
export * from './panel-key'

export const DistributionsPanelConfig: PanelConfig = {
  key: DistributionsKey,
  title: 'Distributions',
  description:
    'Compare expected payments to actual payments including coupons, dividends, and paydowns.',
  category: PanelCategory.ESSENTIALS,
  panelComponent: DistributionsPanelComponent,
  accessPermission: 'accessDistributionsPanel',
}
